<script setup lang="ts">
import { NuxtLink } from '#components'
import type { SiteBlockData, SiteBlockSettings } from '../../../types/site'

defineProps<{ data: SiteBlockData, settings: SiteBlockSettings, editing?: boolean }>()

const isExternal = (url?: string) => !!url && /^(https?:|mailto:|tel:)/.test(url)
</script>

<template>
  <div>
    <!-- `headline` plays the eyebrow role here (a small caption above the
         logos, e.g. "Trusted by") rather than a section title, so it maps to
         SiteSectionHeading's `eyebrow` slot rather than `title`. -->
    <SiteSectionHeading
      :eyebrow="data.headline"
      class="mb-6"
    />
    <div
      v-if="data.logos?.length"
      class="flex flex-wrap items-center justify-center gap-x-10 gap-y-6"
    >
      <component
        :is="logo.link_url ? NuxtLink : 'div'"
        v-for="(logo, i) in data.logos"
        :key="i"
        v-bind="logo.link_url ? { to: logo.link_url, external: isExternal(logo.link_url) } : {}"
      >
        <img
          :src="logo.image"
          :alt="logo.alt || ''"
          class="h-10 w-auto object-contain"
          loading="lazy"
        >
      </component>
    </div>
    <!-- No logos yet: silent on the public page (as before), a click target
         while building — see BlockFrame's `editing` doc comment. -->
    <div
      v-else-if="editing"
      class="flex flex-col items-center gap-2 rounded-[var(--site-radius)] border border-dashed border-[var(--site-border)] p-8 text-center text-sm text-[var(--site-muted)]"
    >
      <svg class="size-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
        <rect x="3" y="7" width="7" height="7" rx="1" />
        <rect x="14" y="7" width="7" height="7" rx="1" />
      </svg>
      <span>Add a logo on the right to fill this in.</span>
    </div>
  </div>
</template>
